import React, { useEffect, useState } from "react";
import i18n from "i18next";

/* eslint-disable react/prop-types */

/**
 * Scene3D kutusunun gövdesi.
 *
 * Bir iframe ile editörün temel çatışması: obje ancak fare olaylarını alırsa
 * çevrilebilir, kutu ise ancak fare olaylarını ALMAZSA taşınıp
 * boyutlandırılabilir. İkisi aynı anda olamaz, o yüzden seçim yazarın:
 *
 *   • Kapalı (varsayılan) — iframe tıklamaları geçirir. Kutu seçilir,
 *     sürüklenir, köşesinden boyutlandırılır. Yazar objenin açılış karesini
 *     görür.
 *   • Açık — iframe olayları alır. Obje çevrilir, patlatılır, yakınlaştırılır,
 *     etiketlerine tıklanır. Bu sırada kutu taşınmaz; düğmeyi kapatmak yeter.
 *
 * Visor'da böyle bir ikilem yok: orada kutu zaten taşınmıyor, obje her zaman
 * etkileşimli.
 *
 * Anahtar kutu seçimini TAKİP EDER: başka bir kutuya geçildiğinde kendini
 * kapatır, yoksa sahnede görünmez bir "fareyi yutan" dikdörtgen kalır ve
 * yazar neden tıklayamadığını anlayamaz.
 */
export default function Scene3DBox({ state, boxId, selected, visor }) {
  const url = (state && state.htmlUrl) || "";
  const [interactive, setInteractive] = useState(false);

  useEffect(() => {
    if (!selected && interactive) setInteractive(false);
  }, [selected, interactive]);

  if (!url) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0b1020",
          color: "#94a3b8",
          fontSize: 13,
        }}
      >
        {i18n.t("Scene3D.Empty", { defaultValue: "3B obje bulunamadı" })}
      </div>
    );
  }

  const frame = (
    <iframe
      src={url}
      title={(state && state.label) || "3D"}
      scrolling="no"
      style={{
        width: "100%",
        height: "100%",
        border: "none",
        background: "transparent",
        pointerEvents: visor || interactive ? "auto" : "none",
      }}
    />
  );

  if (visor) return frame;

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {frame}
      {/* Yalnızca kutu seçiliyken görünür — sahnedeki her 3B objenin üstünde
          duran bir düğme, sahnenin kendisini okunmaz hale getirirdi. */}
      {selected && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            setInteractive((v) => !v);
          }}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
            pointerEvents: "auto",
            padding: "5px 11px",
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            border: `1px solid ${interactive ? "#7c3aed" : "#dce3f3"}`,
            background: interactive ? "#7c3aed" : "rgba(255,255,255,.92)",
            color: interactive ? "#fff" : "#475569",
            boxShadow: "0 1px 4px rgba(15,23,42,.18)",
          }}
          title={
            interactive
              ? i18n.t("Scene3D.InteractOffHint", {
                  defaultValue: "Kutuyu taşımak için kapat",
                })
              : i18n.t("Scene3D.InteractOnHint", {
                  defaultValue: "Objeyi çevirmek/patlatmak için aç",
                })
          }
        >
          {interactive
            ? i18n.t("Scene3D.InteractOff", { defaultValue: "✓ Çevirme açık" })
            : i18n.t("Scene3D.InteractOn", { defaultValue: "Çevir" })}
        </button>
      )}
    </div>
  );
}
